export const CHANGE_FONT_SIZE = 'CHANGE_FONT_SIZE';
export const GET_ROUTE_NAME = 'GET_ROUTE_NAME';
export const GET_REMAIN_TIME = 'GET_REMAIN_TIME';
export const GET_SOCKET_TYPE = 'GET_SOCKET_TYPE';
export const GET_SOCKET_DATA = 'GET_SOCKET_DATA';





// WEBPACK FOOTER //
// ./src/store/anscart/mutations_types.js